export interface ScoreInput {
  han: number;
  fu: number;
  isDealer: boolean;
  isTsumo: boolean;
}

export interface Payment {
  ron?: number;        // 론: 방총자 지불
  tsumoDealer?: number; // 쯔모: 친 지불(자가 화료 시)
  tsumoEach?: number;   // 쯔모: 자 각자 지불(또는 친 화료 시 모두 동일)
  total: number;
}

const ceil100 = (n: number) => Math.ceil(n / 100) * 100;

/** 기본점(base points). 만관 이상은 고정 base로 환산. */
function basePoints(han: number, fu: number): number {
  if (han >= 13) return 8000; // 역만
  if (han >= 11) return 6000; // 삼배만
  if (han >= 8) return 4000;  // 배만
  if (han >= 6) return 3000;  // 하네만
  if (han >= 5) return 2000;  // 만관
  const base = fu * Math.pow(2, 2 + han);
  return Math.min(base, 2000); // 만관 절상(4판30부/3판70부 등)
}

export function computeScore(input: ScoreInput): Payment {
  if (input.han < 1) return { total: 0 };
  const { han, fu, isDealer, isTsumo } = input;
  const base = basePoints(han, fu);

  if (!isTsumo) {
    // 론: 친 base×6, 자 base×4
    const ron = ceil100(base * (isDealer ? 6 : 4));
    return { ron, total: ron };
  }

  // 쯔모
  if (isDealer) {
    const each = ceil100(base * 2);
    return { tsumoEach: each, total: each * 3 };
  }
  const fromDealer = ceil100(base * 2);
  const fromEach = ceil100(base * 1);
  return { tsumoDealer: fromDealer, tsumoEach: fromEach, total: fromDealer + fromEach * 2 };
}
